/**
 * I-03 S3-01.6 — one definition of "is this an ASSORTED box?".
 *
 * Customer-facing payloads deliberately carry no `package_mode` (review
 * #2: a raw field name reached FroggyAI, which quoted it at a shopper) —
 * they carry `package_kind`, the words a person would say. Facility
 * surfaces still get the raw mode, so both are accepted here rather than
 * duplicating the fallback at every call site.
 */
export const ASSORTED_PACKAGE_KIND = 'assorted box — our selection';
export const CURATED_PACKAGE_KIND = 'curated box';

export const isAssortedBox = (entity) => {
  if (!entity || !entity.is_package) return false;
  if (entity.package_kind) {
    return String(entity.package_kind).toLowerCase().startsWith('assorted');
  }
  return entity.package_mode === 'assorted';
};
